// Global

// Local
import HeaderDesktop from 'components/authorable/shared/site-structure/Header/HeaderDesktop';
import HeaderMobile from 'components/authorable/shared/site-structure/Header/HeaderMobile';
import { tv } from 'tailwind-variants';
import useIsEditing from 'lib/hooks/useIsEditing';
import { useIsScrollLocked } from 'lib/hooks/useIsScrollLocked';
import { SiteStructure } from '.generated/Feature.CW.model';

export const Default = (props: SiteStructure.Header.Header_Component) => {
  const isEditing = useIsEditing();
  const isScrollLocked = useIsScrollLocked();

  const { base } = TAILWIND_VARIANTS({
    isEditing,
    isScrollLocked,
  });

  /*
   * Rendering
   */

  if (!props.fields) {
    return <></>;
  }

  return (
    <header
      id="header"
      data-component="authorable/shared/site-structure/header/header"
      className={base()}
    >
      <div className="hidden lg:block">
        <HeaderDesktop {...props} />
      </div>
      <div className="block lg:hidden">
        <HeaderMobile {...props} />
      </div>
    </header>
  );
};

const TAILWIND_VARIANTS = tv({
  slots: {
    base: ['top-0', 'bg-white', 'w-full', 'z-40', 'shadow-global-nav'],
  },
  variants: {
    isEditing: {
      false: {
        base: ['relative'],
      },
      true: {
        base: ['relative'],
      },
    },

    isScrollLocked: {
      false: {
        base: ['fixed'],
      },
      true: {
        base: ['absolute'],
      },
    },
  },
});
